import React from "react";
import { css } from "@emotion/css";
import { Breadcrumb, Col, Container, Row } from "react-bootstrap";
import { useBreadcrumbs } from "./util/BreadcrumbContext";
import { Navigate, useLocation } from "react-router-dom";

const Main = ({ children }) => {
    const { returnToBreadcrumb } = useBreadcrumbs();
    const { state } = useLocation();

    if (!state) {
        return (
            <Navigate
                to="/"
                replace
                state={{ breadcrumbs: [{ href: "/", text: "Welkom" }] }}
            />
        );
    }

    return (
        <div
            id="main"
            className={css`
                width: 100vw;
                height: 100vh;
            `}
        >
            <Container className="w-100 h-100 d-flex" fluid="lg">
                <Row
                    className={css`
                        width: 100%;
                        margin: auto;
                    `}
                >
                    <Col xs={12}>
                        <Breadcrumb className="mt-1">
                            {state?.breadcrumbs?.map(
                                ({ text, disabled }, index) => (
                                    <Breadcrumb.Item
                                        key={index}
                                        active={
                                            index ===
                                            state.breadcrumbs.length - 1 ||
                                            disabled
                                        }
                                        onClick={() =>
                                            returnToBreadcrumb(index)
                                        }
                                    >
                                        {text}
                                    </Breadcrumb.Item>
                                )
                            )}
                        </Breadcrumb>
                        {children}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Main;
